import { AppButton } from 'components/AppButton';
import { FloatingBlurredLayout } from 'components/layouts';
import { getTrans } from 'modules/i18n';
import { ModalName, useModal } from 'modules/modal';
import { useWeekPeriod } from 'modules/week-details';
import { useReason } from '../hooks';

export const FloatingButtons = () => {
  const { reason } = useReason();
  const { isWeekOpen } = useWeekPeriod();
  const { open } = useModal();

  if (!reason) return null;

  return (
    <FloatingBlurredLayout>
      <AppButton
        color="error"
        variant="outlined"
        onClick={() => open(ModalName.deleteReason)}
        disabled={!isWeekOpen}
      >
        {getTrans('reasonDetailsPage.button.deleteReason')}
      </AppButton>
    </FloatingBlurredLayout>
  );
};
